<template>
  <li class="gaishu" :style="{backgroundColor:obj.bc}">
    <div class="tou">
      <div class="fen" :style="{color:obj.bc}"><span style="font-size: 30px;">{{obj.value}}</span>&nbsp;分</div>
      <div class="text" style="width:160px;">
        <h5>{{obj.cname}}</h5>
        <h5>({{obj.yname}})</h5>
      </div>
    </div>
    <div class="text1">
      <p style="margin-top: -5px;text-align: justify;" v-html="str"></p>
    </div>
  </li>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object
      },
      info: {
        type: String
      },
    },
    data() {
      return {
        obj: {
          bc: '',
          cname: '',
          yname: '',
          info: '',
        },
        str:''
      }
    },
    watch:{
      info(v,va){
        this.str = v
      }
    },
    methods: {
      getdata() {
        let _this = this;
        switch (_this.item.name) {
          case 'R':
            _this.obj = {
              bc: '#6392FF',
              cname: '现实型',
              yname: 'Realistic',
            }
            break;
          case 'I':
            _this.obj = {
              bc: '#FF8063',
              cname: '研究型',
              yname: 'Investigative',
            }
            break;
          case 'E':
            _this.obj = {
              bc: '#0DDAFF',
              cname: '管理型',
              yname: 'Enterprising',
            }
            break;
          case 'S':
            _this.obj = {
              bc: '#51CB97',
              cname: '社会型',
              yname: 'Social',
            }
            break;
          case 'C':
            _this.obj = {
              bc: '#3A4D64',
              cname: '常规型',
              yname: 'Conventional',
            }
            break;
          case 'A':
            _this.obj = {
              bc: '#FFBC33',
              cname: '艺术型',
              yname: 'Artistic',
            }
            break;
        }
        _this.obj.value = _this.item.value
        _this.obj.info = _this.item.info
      }

    },
    created() {
      this.getdata();
      console.log(this.item)
    }

  }
</script>

<style>
  .tou{
    display: flex;
    flex-direction: row;
    height: 64px;
    margin-top: 20px;
  }
  .fen{

    background-color: #FFFFFF;
    font-size: 15px;
    font-weight: 800;
    font-family: PingFang SC;
    margin-right: 30px;
    padding: 10px 15px;
    border-radius: 20px;
  }
  .text1{
    flex-grow: 1;
    background-color: #FFFFFF;
    margin: 15px;
    border-radius: 18px;
    padding: 15px;
  }
  .gaishu {
    /* height: 120px; */
    background: #FFBC33;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    color: #FFFFFF;
    font-size: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobType.vue